import { Component, OnInit } from '@angular/core';
import { AnnouncementsService, Template } from '../../../lib/announcements.service';
import { ModalService } from '../../../lib/modal.service';
import { LogService } from '../../../lib/log.service';
import { TemplateEditComponent } from './template-edit/template-edit.component';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {
  templates: Template[] = [];
  isLoading = true;
  constructor(
    private announcementsService: AnnouncementsService,
    private modalService: ModalService,
    private logService: LogService
  ) {}

  ngOnInit(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.isLoading = true;
    this.announcementsService.getTemplates().subscribe(
      (data: Template[]) => {
        this.templates = data;
        this.isLoading = false;
      },
      (error) => {
        this.logService.error(`Error loading templates: ${error}`);
        this.isLoading = false;
        this.modalService.showAlert('Error', 'Failed to load templates');
      }
    );
  }

  doCreate(): void {
    this.modalService.setCloseOnClickAway(false);
    this.modalService.showComponent(TemplateEditComponent).afterClosed().subscribe(result => {
      if (result) {
        this.loadTemplates();
      }
    });
  }

  editTemplate(template: Template): void {
    this.modalService.setCloseOnClickAway(false);
    const modal = this.modalService.showComponent(TemplateEditComponent, {
      templateId: template.ID,
      isEditing: true
    });
    modal.afterClosed().subscribe(result => {
      if (result) {
        this.loadTemplates();
      }
    });
  }

  deleteTemplate(template: Template): void {
    if (template.ID) {
      this.modalService.showConfirmation(
        'Delete Template',
        'Are you sure you want to delete this template for all customers?'
      ).afterClosed().subscribe((result) => {
        if (result) {
          this.announcementsService.deleteTemplate(template.ID).subscribe(
            () => {
              this.loadTemplates();
              this.modalService.showAlert('Success', 'Template deleted successfully');
            },
            (error) => {
              this.logService.error(`Error deleting template: ${error}`);
              this.modalService.showAlert('Error', 'Failed to delete template');
            }
          );
        }
      });
    }
  }

  viewTemplate(template: Template): void {
    this.modalService.setCloseOnClickAway(false);
    const modal = this.modalService.showComponent(TemplateEditComponent, {
      templateId: template.ID
    });
    modal.afterClosed().subscribe(result => {
      if (result) {
        this.loadTemplates();
      }
    });
  }
} 